import analysisModule from "../analysisModule"
import server from "../../server"

analysisModule.service("batchEditionModal", [
    "$modal",
    "$http",
    "$q",
    "loadingService",
    "violationModal",
    "jobService",
    "messagesModal",
    "remoteExceptionHandler",
    ($modal, $http, $q, loadingService, violationModal, jobService, messagesModal, remoteExceptionHandler) => {
        return (batchDTO, refilter) => {
            return $modal.open({
                    templateUrl: require("link!./batchEditionModal.html"),
                    size: "lg",
                    backdrop: "static",
                    keyboard: false,
                    controller: ["$scope", function ($scope) {
                        $scope.batchDTO = batchDTO.tripDTOs
                        $scope.batchDateTime = {}

                        $scope.hasTripWithoutNewDate = function () {
                            return !$scope.batchDTO.every((dto) => !!dto.editLoadTime)
                        }

                        $scope.applyBatchLoadTime = function () {
                            var firstEditLoadTime = $scope.batchDTO[0].editLoadTime
                            for (let i = 1; i < $scope.batchDTO.length; i++) {
                                $scope.batchDTO[i].editLoadTime = firstEditLoadTime
                            }
                        }

                        $scope.save = function () {
                            const editedBatchDTO = $scope.batchDTO.map(function (dto) {
                                if (dto.editLoadTime) {
                                    return {
                                        tripId: dto.id,
                                        loadTime: dto.editLoadTime
                                    }
                                }
                            })
                            return loadingService($http.post(server.getServiceUrl("batch-edition"), editedBatchDTO)
                                .catch(remoteExceptionHandler()))
                                .then((response) => {
                                    return violationModal(response.data)
                                        .then((result) => {
                                            return loadingService($http.post(server.getServiceUrl("batch-edition-confirm-edition"), result.token))
                                        }).then(() => {
                                            return messagesModal("dialog.success", [{
                                                    keyBundle: "trip.edition.success",
                                                    parameters: []
                                                }]
                                            ).then(() => {
                                                refilter.refilter()
                                                $scope.$close()
                                            })
                                        }).catch(() => {
                                            $q.defer().reject()
                                            jobService.cancelJob(response.data.token)
                                        })
                                })
                        }
                    }]
                }
            ).result
        }
    }])